(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("react-controller-context", ["React"], factory);
	else if(typeof exports === 'object')
		exports["react-controller-context"] = factory(require("react"));
	else
		root["react-controller-context"] = factory(root["React"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__156__) => {
return 